import { useEffect, useRef, useState } from "react";
import PageHeader from "../../components/global-layout/page-header";
import ProcessGrid from "../../components/section/process/process-grid";
import { ProcessPageHeaderIcon } from "../../components/svg";
import ProcessMoreInfo from "../../components/section/process/process-more-info";
import ProcessCards from "../../components/section/process/process-cards";
import GridToolBar from "../../components/UI/grid-toolbar";
import GridColumn from "../../components/section/user-management/grid-columns";
import PageLoader from "../../components/UI/page-loader";
import { directService, processServices } from "../../services/InspectionOneServices";
import excelExport from "../../services/excelExport";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import Authentication from "../../auth/Authentication";
import { Outlet, useNavigate } from "react-router-dom";
import CreateInspectionWrapper from "./create-inspection-wrapper";
import { formatDateTime, convertUTCToLocal, useLoadMore } from "../../utils/common";
import OpenPdfModalWrapper from "./open-pdf-download-modal";
import { useMyContext } from "../../components/my-context/MyContext";
import DeleteUser from "../../components/section/user-management/delete-user";
import { generateExcelFileWithMultipleSheets} from "../../services/generateExcelFile";
import ToastifyMessage from "../../lib/toastify";
import { ToastError } from "../../components/UI/toast";

interface Item {
  processName: string;
  processLogic: string;
  inspectedBy: string;
  verificationStatus: string;
  createdDate: string;
  id: string;
}

function Process({ processUpdated, setProcessUpdated }: any) {
  const authService = Authentication();
  const { t } = useTranslation();
  const generateGuid = () => {
    return uuidv4();
  };
  const navigate = useNavigate();
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [processData, setProcessData] = useState<any>([]);
  const [statusDetail, setStatusDetail] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<Item | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSkeletonLoader, setIsSkeletonLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [limit] = useState(20);
  const [initialLoading, setIntialLoading] = useState(true);
  const [finalFetch, setFinalFetch] = useState(false);
  const scrollGroundRef = useRef<any>(null);
  const [sorting, setSorting] = useState<number>(0);
  const [searchedInputVal, setSearchedInputVal] = useState("");
  const [sortingColumnName, setSortingColumnName] = useState<string>("");
  const [pageLoader, setPageLoader] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState<any>(false);
  const [showColumns, setShowColumns] = useState(false);
  const [isGridView, setIsGridView] = useState(false);
  const [toolItems, setToolItems] = useState<any>([]);
  const [searchedQuery, setSearchedQuery] = useState<any>(undefined);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [isRefreshed, setIsRefreshed] = useState<any>(false);
  const [noDataFound, setNoDataFound] = useState<boolean>(false);
  const [isFetchMore, setIsFetchMore] = useState<any>(false);
  const [resetSearch, setResetSearch] = useState<any>(false);
  const [resetFilter, setResetFilter] = useState<any>(false);
  const [siteConfigDetails, setSiteConfigDetails] = useState<any>(false);
  const [accessMode, setAccessMode] = useState<string>("");
  const [userProfileImage, setUserProfileImage] = useState<string>("");
  const [configReportData, setConfigReportData] = useState<any>(false);
  const [deleteData, setDeleteData] = useState(null);
  const [dynmaicExcelUrl, setDynmaicExcelUrl] = useState(null);
  const { ToastifyHandle } = ToastifyMessage();

  const { pageTitle } = useMyContext();
  
  const [selectedColumns, setSelectedColumns] = useState<string[]>([
    "processName",
    "subTitle",
    "processLogic",
    "subProcessLogic",
    "surveyName",
    "inspectedBy",
    "createdDate",
    "verifiedBy",
    "verificationStatus",
  ]);
  const [isUpdated, setIsUpdated] = useState<any>(false);
  const [isInspectionModalOpen, setIsInspectionModalOpen] =
    useState<any>(false);

  const [isPdfModalOpen, setIsPdfModalOpen] = useState<any>(false);

  const [pdfOptions, setPdfOptions] = useState<{ id: number; value: string }[]>([]);

  let columnsRawData = [
    {
      label: configReportData?.processAliasName || "Serial Number",
      token: configReportData?.processAliasName ? "web.process.label.modelName" : "web.process.label.name",
      key: "processName",
      isView: 1,
    },
    {
      label: "Sub Title",
      token: "web.process.label.subTitle",
      key: "subTitle",
      isView: 1,
    },
    {
      label: "Logic Name",
      token: "web.common.label.logicname",
      key: "processLogic",
      isView: 1,
    },
    ...(siteConfigDetails.mode == 1
      ? [
          {
            label: "Screen Mapping Name",
            token: "web.common.label.screenmappingname",
            key: "subProcessLogic",
            isView: 1,
          },
        ]
      : []),
    ...(siteConfigDetails.mode == 2
      ? [
          {
            label: "Screen Collection",
            token: "web.common.label.screencollection",
            key: "surveyName",
            isView: 1,
          },
        ]
      : []),
    {
      label: configReportData?.inspectedByAliasName ||  "Inspected By",
      token: configReportData?.inspectedByAliasName ? "web.common.label.setter": "web.common.label.inspectedby",
      key: "inspectedBy",
      isView: 1,
    },
    {
      label: "Created Date and Time",
      token: "web.common.label.createddate",
      key: "createdDate",
      isView: 1,
    },
    ...(siteConfigDetails.isShiftEnabled
      ? [
          {
            label: "Shift",
            token: "web.common.label.shift",
            key: "shift",
            isView: 0,
          },
        ]
      : []),
      ...(configReportData?.isVerifiedRequired === 1 ? [
        {
            label: "Verified By",
            token: "web.common.label.verifiedBy",
            key: "verifiedBy",
            isView: 1,
          },
          {
            label: "Verified At",
            token: "web.common.label.verifiedAt",
            key: "verifiedDate",
            isView: 0,
          }
      ] : []),
    {
      label: "Verification Status",
      token: "web.common.label.verificationstatus",
      key: "verificationStatus",
      isView: 1,
    },
  ];

  const columnRemoval = configReportData?.columnRemovalKey ?? [];

  const columnsData = columnsRawData.filter(
    (col) => !columnRemoval.includes(col.key)
  );

  useEffect(() => {
    let parsedLoginDetails = null;
    parsedLoginDetails = authService.decryptData("UserDetails", 2);
    parsedLoginDetails = parsedLoginDetails || "{}";
    setAccessMode(parsedLoginDetails.isViewAccess);
    setUserProfileImage(parsedLoginDetails.imageUrl);
    let siteConfigDetails = null;
    siteConfigDetails = authService.decryptData("siteConfigDetails", 2);
    siteConfigDetails = siteConfigDetails || "{}";
    setSiteConfigDetails(siteConfigDetails);
    let parsedReportData = JSON.parse(siteConfigDetails.reportDetails)
    setConfigReportData(parsedReportData);
    setDynmaicExcelUrl(parsedReportData?.excelUrl)
    console.log("pageTitle", pageTitle);
  }, []);

  const handleOpenMoreInfo = (item: Item) => {
    setSelectedItem(item);
    setShowMoreInfo(true);
  };

  const handleRefresh = () => {

    if (!isLoading) {
      setProcessData([]);
      setSortingColumnName("");
      setSorting(0);
      setStartIndex(0);
      setIsRefreshed((prev: any) => !prev);
      setPageLoader(false);
      setSearchedQuery("");
      setSearchedInputVal("");
      setResetSearch(true);
      setResetFilter(true);
      resetProcessFilterState();
    }
  };

  const createNewInspection = () => {
    setIsInspectionModalOpen(true);
  };

  const openPdfModal = async() => {
    try {
      const parsedDetails = JSON.parse(siteConfigDetails.reportDetails);
      const requestJson = {
        masterAccessId: parsedDetails?.masterAccessId 
        ? parsedDetails?.masterAccessId 
        : ""
      };
      const response: any = await processServices.ReportFilter(
        requestJson
      );
      if (response.success) {
        setPdfOptions(response.data.filterDetails);
        setIsPdfModalOpen(true);
      }
    } catch (error) {}
  };

  const handleCheckboxChange = (event: any, key: string) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedColumns((prevSelected) => [...prevSelected, key]);
    } else {
      if (selectedColumns.length === 1) return;
      setSelectedColumns((prevSelected) =>
        prevSelected.filter((item) => item !== key)
      );
    }
  };

  //#region Use Effect
  useEffect(() => {
    const toolItems = siteConfigDetails.isExportRequired
  ? ["search", "export", "refresh", "gridfilter", "pdf"]
  : ["search", "export", "refresh", "gridfilter"];
    if (siteConfigDetails?.isGetStarted === 1) {
      toolItems.unshift("create");
    }
    if (isGridView === true) {
      setToolItems([...toolItems]);
    } else {
      setToolItems([...toolItems, "columns"]);
    }
  }, [isGridView, siteConfigDetails]);

  useEffect(() => {
    if (searchedQuery !== undefined) {
      setProcessData([]);
      setStartIndex(0);
      setSearchedInputVal(searchedQuery);
    }
  }, [searchedQuery]);
  const [processFilterState, setProcessFilterState] = useState({
    dateRange: { startDate: "", endDate: "" },
    shift: { startTime: "", endTime: "", uniqueId: "" },
    processLogicId: "",
    subProcessLogicId: "",
    inspectedByUserUniqueId: "",
    statusId: "",
    refresh: false,
  });
  const resetProcessFilterState = () => {
    setProcessFilterState({
      dateRange: { startDate: "", endDate: "" },
      shift: { startTime: "", endTime: "", uniqueId: "" },
      processLogicId: "",
      subProcessLogicId: "",
      inspectedByUserUniqueId: "",
      statusId: "",
      refresh: false,
    });
  };
  useEffect(() => {
    if (processData === true) {
      setProcessData([]);
      setStartIndex(0);
      setIsUpdated((pre: any) => !pre);
    }
  }, [processUpdated]);
  useEffect(() => {
    if (!isLoading) {
      fetchProcessData(searchedInputVal);
      setResetSearch(false);
      setResetFilter(false);
      setProcessUpdated(undefined);
    }
  }, [
    isFetchMore,
    sortingColumnName,
    sorting,
    searchedInputVal,
    isDeleted,
    isRefreshed,
    processUpdated,
  ]);
  useEffect(() => {
    if (processFilterState.refresh) {
      handleRefresh();
      fetchProcessData(searchedInputVal);
      const updatedFilterState = {
        ...processFilterState,
        refresh: !processFilterState.refresh,
      };

      setProcessFilterState(updatedFilterState);
    }
  }, [resetFilter, processFilterState]);

  const handleNavigate = async (cardData: any) => {
    setPageLoader(true);

    const webSdkUrl = process.env.REACT_APP_WEB_SDK_URL;

    if (cardData && cardData.id) {
      const baseUrl = `${webSdkUrl}/InspectionOne`;
      try {
        const requestJson = {
          uniqueId: generateGuid(),
          logicUniqueId: cardData.processLogicId,
          subLogicUniqueId: cardData.subProcessLogicId,
          processUniqueId: cardData.id,
          sdkPortalLink: baseUrl,
          UserType:
            cardData.verificationStatus === "Verified"
              ? "External"
              : accessMode === "0"
              ? "Internal"
              : "External",
          languageCode: "en",
          userProfileImage: userProfileImage,
        };
        const response: any = await processServices.ProcessAuthTokenAction(
          requestJson
        );
        if (response.success) {
          const { authToken, siteId, languageCode, sdkLink  } = response.data;
          let url = `${baseUrl}/${authToken}/${siteId}/${languageCode}`;
          if( sdkLink && sdkLink !== ""){
            url = sdkLink;
          }
          window.open(url, "_blank");
        }
        setPageLoader(false);
      } catch (error) {
        setPageLoader(false);
        console.error("Error fetching data:", error);
      }
    }
  };
  //#endregion
  const getProcessStatusData = (
    processLogicId: any,
    subProcessLogicId: any,
    statusDetail: any,
    statusId: any
  ) => {
    if (statusDetail) {
      const optionData =
        (statusDetail[processLogicId] &&
          statusDetail[processLogicId][subProcessLogicId]) ||
        [];
      const filteredStatuses = optionData.filter((status: any) => {
        return status.id === statusId;
      });
      return filteredStatuses;
    }
    return [];
  };

  //#region list Fetch
  const fetchProcessData = async (query: any) => {
    if (!isLoading) {
      setIsLoading(true);
      setIsSkeletonLoader(true);
      setFinalFetch(false);
      setNoDataFound(false);
      try {
        const requestJson = {
          filterDetails: {
            searchValue: query,
            startIndex: startIndex,
            limit: limit,
            startDate: processFilterState.dateRange.startDate,
            endDate: processFilterState.dateRange.endDate,
            sorting: sorting,
            columnName: sortingColumnName,
            isShiftEnabled: siteConfigDetails?.isShiftEnabled ?? 0,
            startTime: processFilterState?.shift?.startTime ?? "",
            endTime: processFilterState?.shift?.endTime ?? "",
            processLogicUniqueId: processFilterState.processLogicId ?? "",
            subProcessLogicUniqueId: processFilterState.subProcessLogicId ?? "",
            inspectedByUserUniqueId: processFilterState.inspectedByUserUniqueId ?? "",
            statusId: processFilterState.statusId ?? "",
          },
        };
        const response: any = await processServices.ProcessLists(requestJson);
        if (response.success) {
          const responseData = response.data.processDetails;
          setTotalCount(response.data.totalCount);
          setStatusDetail(response.data.statusDetail);
          const newArray = responseData.map((item: any) => ({
            processLogicId: item.processLogicId,
            subProcessLogicId: item.subProcessLogicId,
            processName: item.title === "" ? "No Label" : item.title,
            subTitle: item.subtitle.length === 0 ? "-" : item.subtitle,
            processLogic: item.processLogicName,
            subProcessLogic: item.subProcessLogicName,
            surveyName: item.surveyName,
            inspectedBy: item.createdBy,
            verifiedBy : item.verifiedBy ? item.verifiedBy : "-",
            verificationStatus: item.displayStatus,
            isViewOnly: item.isViewOnly,
            verificationColour: getProcessStatusData(
              item.processLogicId,
              item.subProcessLogicId,
              response.data.statusDetail,
              item.statusId
            ),
            createdDate: new Date(item.createdAt)
              .toLocaleString("en-US", {
                month: "short", // "Feb"
                day: "numeric", // "3"
                year: "numeric", // "2025"
                hour: "2-digit", // "01"
                minute: "2-digit", // "07"
                hour12: true, // Ensures AM/PM format
              })
              .replace(",", ""),

            verifiedDate : item.verifiedAt ? new Date (item.verifiedAt)
              .toLocaleString("en-US", {
                month: "short", // "Feb"
                day: "numeric", // "3"
                year: "numeric", // "2025"
                hour: "2-digit", // "01"
                minute: "2-digit", // "07"
                hour12: true,
              }) : "-" ,
            moreDetails: item.moreDetails,
            statusId: item.statusId,
            processLogicUniqueId: item.processLogicUniqueId,
            icon: item.icon,
            uniqueId: item.uniqueId,
            id: item.id,
            isOverridden: item.isOverridden,
          }));
          setProcessData((prevData: any) => [...prevData, ...newArray]);
          setIsLoading(false);
          setIsSkeletonLoader(false);
          if (!responseData.length) {
            setNoDataFound(true);
          } else {
            setNoDataFound(false);
          }
          if (startIndex < limit) {
            setIntialLoading(false);
          }
        }
        // setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setIsSkeletonLoader(false);
        console.error("Error fetching data:", error);
      }
    }
  };
  //#endregion
  //#region Scroll
  const { handleScroll } = useLoadMore(
    startIndex,
    limit,
    totalCount,
    setStartIndex,
    setIsFetchMore,
    setFinalFetch,
    scrollGroundRef
  );
  //#endregion
  //#region Sorting
  const handleSort = (column: any, value: number, columnName: string) => {
    setProcessData([]);
    setStartIndex(0);
    setSorting(value);
    setSortingColumnName(columnName);
  };
  //#endregion
  //#region  Excel Export
  const [isExcelLoading, setExcelLoading] = useState(false);
  const [isPdfLoading, setPdfLoading] = useState(false);
  const handleExcel = async () => {
    setExcelLoading(true);
    if (dynmaicExcelUrl) {
      if (
        handleValidateDaterange(
          processFilterState.dateRange.startDate,
          processFilterState.dateRange.endDate
        )
      ) {
        try {
          const requestData = {
            fromDate: processFilterState.dateRange.startDate,
            toDate: processFilterState.dateRange.endDate,
          };
          const response = await directService.DirectPostServices(
            dynmaicExcelUrl,
            requestData
          );
          if (response.success) {
            const excelDatas = response.data.excelDatas;

            excelDatas.forEach((sheet: { excelData: any[] }) => {
              sheet.excelData.forEach((row) => {
                if (row.settingStartTime) {
                  row.settingStartTime = convertUTCToLocal(
                    row.settingStartTime
                  );
                }
                if (row.settingEndTime) {
                  row.settingEndTime = convertUTCToLocal(row.settingEndTime);
                }
                if (row.verifiedAt) {
                  row.verifiedAt = convertUTCToLocal(row.verifiedAt);
                }
              });
            });

            const fileName = "AI Logic Results";

            generateExcelFileWithMultipleSheets(excelDatas, fileName);
          }
          setExcelLoading(false);
        } catch (error) {
          setExcelLoading(false);
        }
      }
    } else {
      const screenName = "ailogicresults";
      let fileName = "AI Logic Results";
      const sheetName = "AI_Logic_Results";

      if (
        processFilterState?.dateRange?.endDate ||
        processFilterState?.dateRange?.startDate ||
        (processFilterState?.shift?.startTime &&
          processFilterState?.shift?.endTime)
      ) {
        const formatDate = (date: string) => {
          return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }).format(new Date(date));
        };

        const formatTime = (time: string) => {
          const [hours, minutes] = time.split(":").map(Number);
          const date = new Date();
          date.setHours(hours, minutes);
          return new Intl.DateTimeFormat("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }).format(date);
        };

        let datePart = "";

        if (
          processFilterState.dateRange.startDate ||
          processFilterState.dateRange.endDate
        ) {
          if (
            processFilterState.dateRange.startDate ===
            processFilterState.dateRange.endDate
          ) {
            // If startDate and endDate are the same, only show a single date
            datePart = `${formatDate(processFilterState.dateRange.startDate)}`;
          } else {
            // If startDate and endDate are different, show the range
            datePart = `${formatDate(
              processFilterState.dateRange.startDate
            )} - ${formatDate(processFilterState.dateRange.endDate)}`;
          }
        } else if (processFilterState.dateRange.startDate) {
          // If only startDate is provided
          datePart = formatDate(processFilterState.dateRange.startDate);
        } else {
          // If no dates are provided
          datePart = "";
        }

        // const shiftPart =
        //   processFilterState.shift.startTime && processFilterState.shift.endTime
        //     ? `${formatTime(processFilterState.shift.startTime)} - ${formatTime(
        //         processFilterState.shift.endTime
        //       )}`
        //     : "";

        // Construct the file name dynamically
        //fileName += ` (${datePart}, ${shiftPart})`;
        fileName += ` (${datePart})`;
      }

      try {
        await excelExport.excelExport(
          screenName,
          fileName,
          sheetName,
          columnsData,
          "",
          siteConfigDetails.shiftsDetails,
          processFilterState.dateRange.startDate,
          processFilterState.dateRange.endDate,
          processFilterState.shift.startTime,
          processFilterState.shift.endTime,
          siteConfigDetails.isShiftEnabled ?? 0,
          processFilterState.processLogicId ?? "",
          processFilterState.subProcessLogicId ?? "",
          processFilterState.inspectedByUserUniqueId ?? "",
          processFilterState.statusId ?? "",
        );
        setExcelLoading(false);
      } catch (error) {
        console.error("Export failed:", error);
        setExcelLoading(false);
      }
    }
    setExcelLoading(false);
  };

  const handleExportClick = async (rowData: any) => {
    try {
      const requestJson = {
        id: rowData.id,
        processLogicId: rowData.processLogicId,
        subProcessLogicId: rowData.subProcessLogicId,
        startDate: processFilterState.dateRange.startDate,
        endDate: processFilterState.dateRange.endDate,
      };
      const response: any = await processServices.ProcessExportAction(
        requestJson
      );
      if (response.success){
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "exported_file_name.extension");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {}
  };

  const handleDownloadClick = async (rowData: any) => {
    try {
      setIsLoading(true);
      const parsedDetails = JSON.parse(siteConfigDetails.reportDetails);
      const requestJson = {
        filterValue: rowData.subTitle[0],
        masterAccessId: parsedDetails?.masterAccessId 
        ? parsedDetails?.masterAccessId 
        : ""
      };
      const response: any = await processServices.PdfGenerate(
        requestJson
      );
      if (response.success) {
        setIsLoading(false);
        const link = document.createElement("a");
        link.href = response.data.responseResult.bloburl;
        link.setAttribute("download", "exported_file_name.extension");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  //#endregion

  //#deleteProcess
  const handleDelteProcess = async (data:any) =>{
    try{
      const requestData = {
        processId : data.id
      }
      const response = await processServices.processDelete(requestData);
      if(response.success){
        setShowDeletePopup(false);
        setDeleteData(null);
        handleRefresh();
      }
    }
    catch(error){
      console.log(error)
    }
  }


  
  const deleteProcessData = (data: any) => {
    setDeleteData(data)
    setShowDeletePopup(true)
  }


  //#endregion

  const handleError = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastError title={titleName} description={message} />,
      "error"
    );
  };

  const handleValidateDaterange =( startDate : any, endDate : any )=>{
    if(startDate == "" && endDate == ""){
      handleError("Please select date range", "");
      return false
    }
    else {
      return true
    }
  } 

  return (
    <>
      <div className="w-full h-full flex flex-col">
        <PageHeader
          title={t(pageTitle)}
          icon={<ProcessPageHeaderIcon />}
        />
        <div className="w-full flex-1">
          <div className="w-full h-full flex flex-col">
            <GridToolBar
              columnCount={totalCount}
              gridType={t("web.toolbar.label.ailogicresults")}
              selectView={true}
              tools={toolItems}
              handleAddRow={createNewInspection}
              handleColumns={() => setShowColumns(true)}
              isGridView={isGridView}
              fetchData={(query: any) => setSearchedQuery(query)}
              getSearchedQuery={(query: any) => setSearchedQuery(query)}
              handleRefresh={handleRefresh}
              handleExcel={handleExcel}
              isExcelLoading={isExcelLoading}
              isSkeletonLoader={isSkeletonLoader}
              resetSearch={resetSearch}
              resetFilter={resetFilter}
              setIsGridView={(isChecked: any) => setIsGridView(isChecked)}
              siteConfigDetails={siteConfigDetails}
              processFilterState={processFilterState}
              setProcessFilterState={setProcessFilterState}
              setStartIndex={setStartIndex}
              handlePdfDownload={openPdfModal}
              isPdfLoading={isPdfLoading}
              setPdfLoading={setPdfLoading}
            />
            <div className="w-full flex-1">
              {isGridView ? (
                <ProcessCards
                  handleNavigate={handleNavigate}
                  rowData={processData}
                  scrollGroundRef={scrollGroundRef}
                  handleScroll={handleScroll}
                  initialLoading={initialLoading}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  limit={limit}
                  finalFetch={finalFetch}
                  handleOpenMoreInfo={handleOpenMoreInfo}
                  handleExportClick={handleDownloadClick}
                  noDataFound={noDataFound}
                  siteConfigDetails={siteConfigDetails}
                />
              ) : (
                <ProcessGrid
                  selectedColumns={selectedColumns}
                  rowSelection={false}
                  moreOptions={true}
                  handleNavigate={handleNavigate}
                  rowData={processData}
                  scrollGroundRef={scrollGroundRef}
                  handleScroll={handleScroll}
                  initialLoading={initialLoading}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  limit={limit}
                  finalFetch={finalFetch}
                  sorting={sorting}
                  sortingColumnName={sortingColumnName}
                  handleSort={handleSort}
                  handleCheckboxChange={handleCheckboxChange}
                  handleOpenMoreInfo={handleOpenMoreInfo}
                  noDataFound={noDataFound}
                  siteConfigDetails={siteConfigDetails}
                  handleDelete = {deleteProcessData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {showMoreInfo && (
        <ProcessMoreInfo
          statusDetail={statusDetail}
          selectedItem={selectedItem ? [selectedItem] : []}
          handleClose={() => setShowMoreInfo(false)}
          processUpdated={(val: boolean) => setProcessUpdated(val)}
          handleRefresh={handleRefresh}
        />
      )}
      {showColumns && (
        <GridColumn
          handleClose={() => setShowColumns(false)}
          handleCheckboxChange={handleCheckboxChange}
          columnsData={columnsData}
          selectedColumns={selectedColumns}
        />
      )}
      {pageLoader && <PageLoader />}
      {/* <Outlet /> */}
      {isInspectionModalOpen && (
        <CreateInspectionWrapper
          handleRefresh={handleRefresh}
          setIsInspectionModalOpen={setIsInspectionModalOpen}
          processUpdated={() => setProcessUpdated((pre: any) => !pre)}
        />
      )}
      {isPdfModalOpen && (
        <OpenPdfModalWrapper
          handleRefresh={handleRefresh}
          setIsPdfModalOpen={setIsPdfModalOpen}
          processUpdated={() => setProcessUpdated((pre: any) => !pre)}
          siteConfigDetails={siteConfigDetails}
          pdfOptions={pdfOptions}
          isPdfLoading={isPdfLoading}
          setPdfLoading={setPdfLoading}
        />
      )}
      {showDeletePopup && (
        <DeleteUser
          rowData={deleteData} 
          handleCancel={() => setShowDeletePopup(false)}
          handleDelete={(data : any) => handleDelteProcess(data)}
          actionFlag="process"
        />
      )}
    </>
  );
}
export default Process;
